import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { User } from '../../interfaces/user.interface';
import { ActivityLogsService } from '../../services/activity-logs/activity-logs.service';
import { ActivityLogDto } from '../../types/activity-log.types';

@Directive({
  selector: '[psUiActivityLog]',
})
export class ActivityLogDirective implements OnInit, OnDestroy {
  @Input()
  public logMessage: string;

  @Input()
  public category?: string;

  @Input()
  public logSurveyId?: number;

  @Input()
  public logSurveyStatus?: string;

  @Input()
  public logUser?: User;

  @Input()
  public logOrigin?: string;

  @Input()
  public logFeatureId?: string;

  @Input()
  public logFeatureName?: string;

  @Input()
  public logAddInfo?: string;

  @Input()
  public logListenEvent: string = 'click';

  @Input()
  public logMetadata?: Record<string, unknown> = {};

  private dispose!: Function;

  constructor(
    private render: Renderer2,
    private elementRef: ElementRef,
    public readonly activityLogService: ActivityLogsService
  ) {}

  public ngOnInit(): void {
    this.dispose = this.render.listen(
      this.elementRef.nativeElement,
      this.logListenEvent,
      () => {
        const _user = this.logUser || { token: '' };
        const { token, ...user } = _user;

        const dto: ActivityLogDto = {
          eventSource: 'user',
          logMessage: this.logMessage,
          user: user as User,
          surveyId: this.logSurveyId,
          surveyStatus: this.logSurveyStatus,
          origin: this.logOrigin,
          featureId: this.logFeatureId,
          featureName: this.logFeatureName,
          addInfo: this.logAddInfo,
          category: this.category,
          metadata: this.logMetadata,
        };

        // send activity log
        this.activityLogService.post(dto).subscribe();
      }
    );
  }

  public ngOnDestroy(): void {
    this.dispose();
  }
}
